import { useEffect, useMemo } from 'react';
import { MapContext } from '@robinpowered/atlas-web';
import { MapboxFeature } from '@robinpowered/atlas-common';
import {
  createNeighborhoodsCentroidsBuckets,
  createNeighborhoodsFeaturesBuckets,
  addNeighborhoodSources,
  addNeighborhoodLayers,
} from './utils';
import { Position } from 'geojson';

interface UseNeighborhoodMapInteractionsInterface {
  getNeighborhoodCentroid: (neighborhood: {
    id: string;
    desks: { id: string }[];
  }) => Position | undefined;
}

export const useNeighborhoodMapInteractions = (
  map: MapContext,
  seatFeatures: MapboxFeature[],
  neighborhoods: { id: string; desks: { id: string }[] }[]
): UseNeighborhoodMapInteractionsInterface => {
  const featuresBuckets = useMemo(
    () => createNeighborhoodsFeaturesBuckets(neighborhoods, seatFeatures),
    [neighborhoods, seatFeatures]
  );

  const centroidsBuckets = useMemo(
    () => createNeighborhoodsCentroidsBuckets(featuresBuckets),
    [featuresBuckets]
  );

  // Initialize neighborhoods on map.
  useEffect(() => {
    if (map) {
      addNeighborhoodSources(map);
      addNeighborhoodLayers(map);
    }
  }, [map]);

  const getNeighborhoodCentroid = (neighborhood: {
    id: string;
    desks: { id: string }[];
  }): Position | undefined => {
    return centroidsBuckets[neighborhood.id];
  };

  return {
    getNeighborhoodCentroid,
  };
};
